const ENABLED_ENVIRONMENTS = new Set(['staging', 'production']);

export function getAnalyticsEnvironment() {
  return process.env.NEXT_PUBLIC_ENVIRONMENT ?? 'unknown';
}

export function isAnalyticsEnabled() {
  if (process.env.NEXT_PUBLIC_E2E === 'true') {
    return false;
  }

  if (!ENABLED_ENVIRONMENTS.has(getAnalyticsEnvironment())) {
    return false;
  }

  return Boolean(process.env.NEXT_PUBLIC_POSTHOG_PROJECT_TOKEN);
}

export function isServerAnalyticsEnabled() {
  return isAnalyticsEnabled() && Boolean(process.env.POSTHOG_IDENTIFY_SECRET);
}
